module.exports = __webpack_public_path__ + "static/media/cube.3b49f388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cube.svg
// module id = 388
// module chunks = 35